import { Component, OnInit } from '@angular/core';
import { CommonApiService } from '../CommonController/common-api-service';

import { HttpErrorResponse } from '@angular/common/http';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatOption, MatSelect } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { DeviceModelApiService } from '../CommonController/device-model-api-service';
import { SamparkEolApiService } from '../CommonController/sampark-eol-api-service';
import { SharedValidators } from '../shared/validators/shared-validators';

@Component({
  selector: 'app-sampark-eol-device-add-page',
  templateUrl: './sampark-eol-device-add-page.component.html',
  styleUrls: ['./sampark-eol-device-add-page.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatIcon,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    MatSelect,
    MatOption,
  ],
})
export class SamparkEolDeviceAddPageComponent implements OnInit {
  imei = '';
  samparkEolDeviceAddForm!: FormGroup;

  userPermission = [];
  loggedId = '';
  SamparkEolDeviceAdd = true;
  SamparkEolDeviceUpdate = true;
  accountIdOptions = [
    { label: 'Sampark 4G CAN', value: 35, deviceTypeName: 'TPSM4G_TML' },
    { label: 'Sampark 4G', value: 46, deviceTypeName: 'TPSM_TML' },
  ];
  // protocolOptions = [
  //   { label: 'TCP', value: 'TCP' },
  //   { label: 'MQTT', value: 'MQTT' },
  // ];

  constructor(
    public samparkEolApiService: SamparkEolApiService,
    public commonApiService: CommonApiService,
    private fb: FormBuilder,
    public router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    public deviceModelApiService: DeviceModelApiService
  ) {}

  ngOnInit(): void {
    this.imei = this.route.snapshot.paramMap.get('id') || '';
    this.checkPermission();
    this.setSamparkEolDeviceAddForm();
    if (this.imei) {
      this.SamparkEolDeviceUpdate = true;
      this.SamparkEolDeviceAdd = false;
      this.prepopulation(this.imei);
    } else {
      this.SamparkEolDeviceUpdate = false;
      this.SamparkEolDeviceAdd = true;
    }
  }

  checkPermission() {
    this.loggedId = sessionStorage.getItem('loggedInUserId') || '';
    this.userPermission = JSON.parse(
      sessionStorage.getItem('userPermissions') || '[]'
    );
    if (this.imei !== null) {
      this.userPermission.forEach((element: any) => {
        if (element.pageName === 'Sampark EOL') {
          if (element.update === false) {
            this.navigateBack();
          }
        }
      });
    } else {
      this.userPermission.forEach((element: any) => {
        if (element.pageName === 'Sampark EOL') {
          if (element.create === false) {
            this.navigateBack();
          }
        }
      });
    }
  }

  setSamparkEolDeviceAddForm() {
    this.samparkEolDeviceAddForm = this.fb.group({
      imei: new FormControl('', [
        SharedValidators.lengthCheckValidator(15, {
          onlyNumbers: true,
          required: true,
        }),
      ]),
      vinNo: new FormControl('', [
        SharedValidators.lengthCheckValidator(17, {
          required: true,
        }),
      ]),
      locationName: new FormControl('Service'),
      accountId: new FormControl('', SharedValidators.requiredAndNoEmptySpaces),
      deviceTypeName: new FormControl({ value: '', disabled: true }),
      protocolTypeName: new FormControl('TCP'),
      tcuSerialNumber: new FormControl(''),
      tcuPartNumber: new FormControl(''),
      vehicleType: new FormControl('CV'),
      transmissionType: new FormControl('Manual'),
      userId: new FormControl(
        this.loggedId,
        SharedValidators.requiredAndNoEmptySpaces
      ),
    });

    this.registerAccountIdListener();
  }

  prepopulation(imei: string) {
    this.spinner.show();
    this.samparkEolApiService.getSamparkEolDeviceById(imei).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        const data = res.data;
        this.samparkEolDeviceAddForm = this.fb.group({
          imei: new FormControl(data.imei, [
            SharedValidators.lengthCheckValidator(15, {
              onlyNumbers: true,
              required: true,
            }),
          ]),
          vinNo: new FormControl(data.vinNo, [
            SharedValidators.lengthCheckValidator(17, { required: true }),
          ]),
          locationName: new FormControl('Service'),
          accountId: new FormControl(Number(data.accountId) || data.accountId, [
            SharedValidators.requiredAndNoEmptySpaces,
          ]),
          deviceTypeName: new FormControl({
            value: data.deviceTypeName,
            disabled: false,
          }),
          protocolTypeName: new FormControl('TCP'),
          tcuSerialNumber: new FormControl(data.tcuSerialNumber),
          tcuPartNumber: new FormControl(data.tcuPartNumber),
          vehicleType: new FormControl('CV'),
          transmissionType: new FormControl('Manual'),
          userId: new FormControl(
            this.loggedId,
            SharedValidators.requiredAndNoEmptySpaces
          ),
        });

        this.registerAccountIdListener();
        this.onAccountIdChange(data.accountId);
      } else {
        console.error('API Response error:', res.message);
      }
    });
  }

  onAccountIdChange(value: number | string | null): void {
    const selected = this.accountIdOptions.find((option) => {
      const rawValue =
        value === null || value === undefined ? '' : value.toString();
      return (
        option.label === value ||
        option.value === value ||
        option.value.toString() === rawValue
      );
    });
    const deviceTypeControl =
      this.samparkEolDeviceAddForm.get('deviceTypeName');

    if (!selected) {
      deviceTypeControl?.reset();
      deviceTypeControl?.disable({ emitEvent: false });
      return;
    }

    deviceTypeControl?.enable({ emitEvent: false });
    deviceTypeControl?.setValue(selected.deviceTypeName, { emitEvent: false });
  }

  private registerAccountIdListener(): void {
    this.samparkEolDeviceAddForm
      .get('accountId')
      ?.valueChanges.subscribe((value) => {
        this.onAccountIdChange(value);
      });
  }

  validateFormUpdate() {
    if (this.samparkEolDeviceAddForm.invalid) {
      SharedValidators.markAllAsTouched(this.samparkEolDeviceAddForm);
      return;
    } else {
      this.updateData();
    }
  }

  validateFormSave() {
    if (this.samparkEolDeviceAddForm.invalid) {
      SharedValidators.markAllAsTouched(this.samparkEolDeviceAddForm);
      return;
    } else {
      this.saveData();
    }
  }

  saveData() {
    const payload = this.samparkEolDeviceAddForm.value;
    payload.createdAt = Date.now();
    this.spinner.show();
    this.samparkEolApiService.saveSamparkEolDevice(payload).subscribe({
      next: (res) => {
        if (res.status) {
          this.spinner.hide();
          this.commonApiService.openSnackbar(res.message);
          this.router.navigate(['sampark-eol-page']);
        } else {
          this.spinner.hide();
          this.commonApiService.openSnackbar(res.message);
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.commonApiService.openSnackbar(ERROR.error.message);
      },
    });
  }

  updateData() {
    this.spinner.show();
    const payload = this.samparkEolDeviceAddForm.value;
    payload.id = this.imei;
    payload.updatedAt = Date.now();
    this.samparkEolApiService.updateSamparkEolDeviceData(payload).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) {
          this.redirect('sampark-eol-page');
          this.SamparkEolDeviceUpdate = false;
          this.SamparkEolDeviceAdd = true;
          this.commonApiService.openSnackbar(res.message);
        } else {
          this.commonApiService.openSnackbar(res.message);
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.commonApiService.openSnackbar(ERROR.error.message);
      },
    });
  }

  redirect(to: string): void {
    this.router.navigate([to]);
  }

  navigateBack() {
    this.commonApiService.back();
  }
}
